import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RRLink } from 'react-router-dom';

import { Center, Text, Link, Icon, HStack } from '@wegroup/design-system';
import DisabledModulePagePicture from './DisabledModulePagePicture';
import GeneralPageLayout from '../../../../common/src/components/GeneralPageLayout';

interface Props {
  pageName: string;
  noRedirect?: boolean;
}

const DisabledModulePage: React.FC<Props> = ({ pageName, noRedirect }) => {
  const { t } = useTranslation();

  return (
    <GeneralPageLayout>
      <Center w="100%" h="100vh" flexDirection="column">
        <DisabledModulePagePicture h="40%" />
        <Text mt="8" textStyle="h2Headline">
          {pageName} {t('MAINTENANCE_TITLE')}
        </Text>
        <Text mt="4" maxW="container.sm" textAlign="center">
          {pageName} {t('MAINTENANCE_DESC')}
        </Text>
        {!noRedirect && (
          <Link variant="gray" mt="8" as={RRLink} to="/">
            <HStack>
              <Icon name="GeneralActionsArrowLeft" />
              <Text>{t('Go back to dashboard')}</Text>
            </HStack>
          </Link>
        )}
      </Center>
    </GeneralPageLayout>
  );
};

export default DisabledModulePage;
